import { render } from "./StaffRoleItem.vue?vue&type=template&id=5c018dd6"
import script from "./StaffRoleItem.vue?vue&type=script&lang=js"
export * from "./StaffRoleItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__